module.exports = __webpack_public_path__ + "img/mine_rz2.18598e1a.png";